// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__vMWmO","header":"Page_header__sFz--","goBack":"Page_goBack__35hBW","title":"Page_title__13EiF","pageContent":"Page_pageContent__ZKP5O"};